import * as React from 'react';

export default class FaultTest extends React.Component<any, any> {
  public componentDidMount() {
    throw Error('Testing Error Handling');
  }

  public render() {
    return null;
  }
}
